import React, { useState } from 'react';

import InsertButton from '../../elements/InsertButton';
import Loader from '../../elements/Loader';
import axios from '../../services/MyAxios';

import { CRM_PERMISSION } from '../pages/Helpers/CrmPermissions';

import CasinoGame from 'casino/Api/Models/CasinoGame';
import useDebounce from 'hooks/useDebounce';

// eslint-disable-next-line react/prop-types
function GameSearchInput({ action, allowedTypes, liveOnly, insertUrl }) {
    const [matchingGames, setMatchingGames] = useState<CasinoGame[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showResults, setShowResults] = useState(false);
    const endpoint = '/crea/casino/api/games';
    const minCharsToSearch = 3;

    const getMatchingGames = (searchedValue) => {
        axios
            .get(endpoint, {
                params: {
                    filter: searchedValue,
                    types: allowedTypes,
                    withLobbyOnly: liveOnly,
                },
            })
            .then((response) => {
                setMatchingGames(response.data);
                setIsLoading(false);
                setShowResults(true);
                action();
            });
    };

    const handleSearchChange = (event) => {
        setShowResults(false);
        const searchedValue = event.target.value;
        if (searchedValue.length < minCharsToSearch) {
            return;
        }

        setIsLoading(true);

        getMatchingGames(searchedValue);
    };

    const debouncedHandleSearchChange = useDebounce(handleSearchChange, 500);

    const createRequestData = (gameId) => {
        return {
            game_id: gameId,
        };
    };

    const renderResults = () => {
        return (
            <div style={{ display: showResults ? 'block' : 'none' }}>
                {matchingGames.length > 0 ? (
                    <ul
                        className="position-absolute bg-white p-2 border"
                        style={{ right: 18, zIndex: 9, height: '50%', overflowY: 'scroll' }}
                    >
                        {matchingGames.map((game) => {
                            return (
                                <li className="d-flex mb-4 align-items-center text-left" key={game.id}>
                                    <img
                                        className="w-25 mr-4"
                                        src={game.image}
                                        alt={`${game.name} ${game.creator_name}`}
                                    />
                                    <div>
                                        <div className="game-search-input-name-and-platform-container">
                                            {game.is_mobile && <i className="mdi mdi-cellphone" />}
                                            {game.is_desktop && <i className="mdi mdi-desktop-mac" />}
                                            <span>{game.name}</span>
                                        </div>
                                        <h5>{game.creator_name}</h5>
                                        <InsertButton
                                            url={insertUrl}
                                            requestData={createRequestData(game.id)}
                                            action={() => action()}
                                            permissions={[CRM_PERMISSION.GAME_CATEGORY_INSERT_GAME]}
                                            roles={undefined}
                                        />
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                ) : (
                    <span className="text-danger">Cannot find any game</span>
                )}
            </div>
        );
    };

    return (
        <div className="bg-white text-right p-4 mb-4">
            <div className="col-sm-12 col-md-6 col-lg-3 search-container">
                <i className="fa fa-search search-icon" />
                <input
                    className="form-control form-control search-box"
                    type="search"
                    name="filter"
                    placeholder="Search a game"
                    onChange={debouncedHandleSearchChange}
                />
            </div>

            <Loader loading={isLoading} content={renderResults} />
        </div>
    );
}
export default GameSearchInput;
